<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Vendor</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <router-link :to="{ name: 'vendor-view' }">Vendor List</router-link>
      /
      <b>Company List</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <h4>
          <b>Vendor: {{ vendor_name }}</b>
        </h4>
      </div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button
            class="btn btn-secondary"
            id="btn-active"
            type="button"
            :class="{ 'change-background': activeClick }"
            @click="active1()"
          >
            Active
          </button>
          <button
            class="btn btn-secondary"
            id="btn-pending"
            type="button"
            :class="{ 'change-background': !activeClick }"
            @click="pending1()"
          >
            Pending
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- <p>Add new banner and company detail to be shown on Takaful Brunei Mobile App</p> -->

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class>
              <h4 class="card-title mb-3">
                <b>Active</b>
              </h4>

              <!-- Active -->
              <div class="table-responsive">
                <table
                  id="active_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Banner</th>
                      <th>Description</th>
                      <th>Remarks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="active != null">
                      <td>1</td>
                      <td>{{ active.name }}</td>
                      <td><img height="60px" :src="active_src" /></td>
                      <td>{{ active.description }}</td>
                      <td>{{ active.remarks }}</td>
                      <td>
                        <router-link
                          :to="redirect('update')"
                          class="btn btn-primary btn-rounded btn-block"
                          >View Details</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Pending -->
            <div id="pending" class="d-none">
              <h4 class="card-title mb-3">
                <b>Pending</b>
              </h4>
              <p>
                The table shows the pending list of pending request approval
              </p>

              <div class="table-responsive">
                <table
                  id="pending_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Banner</th>
                      <th>Description</th>
                      <th>Remarks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="pending != null">
                      <td>1</td>
                      <td>{{ pending.name }}</td>
                      <td><img height="60px" :src="pending_src" /></td>
                      <td>{{ pending.pending_description }}</td>
                      <td>{{ pending.remarks }}</td>
                      <td>
                        <router-link
                          :to="redirect('update')"
                          class="btn btn-primary btn-rounded btn-block"
                          >View Details</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-products",
  components: {},

  data() {
    return {
      active: [],
      pending: [],
      id: "",
      active_src: "",
      pending_src: "",
      vendor_name: "",
      activeClick: true
    };
  },

  methods: {
    loadVendor() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/vendor/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.active = res.data.vendor;

            this.id = this.active.id;

            if (
              this.active.pending_banner_link != null ||
              this.active.pending_description != null
            ) {
              this.pending = this.active;

              this.loadPendingImage(token);
            } else {
              this.pending = null;
            }

            this.loadActiveImage(token);
          })
          .then(function() {
            $("#active_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                }
              ]
            });

            $("#pending_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                }
              ]
            });
          });
      }
    },

    loadPendingImage(token) {
      axios
        .get(axios.lpsURL + "/vendor/banner/" + this.id + "/show/pending", {
          headers: {
            Authorization: "Bearer " + token
          },
          responseType: "blob"
        })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.pending_src = reader.result;
          };
        });
    },

    loadActiveImage(token) {
      axios
        .get(axios.lpsURL + "/vendor/banner/" + this.id + "/show/active", {
          headers: {
            Authorization: "Bearer " + token
          },
          responseType: "blob"
        })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.active_src = reader.result;
          };
        });
    },

    loadData() {
      this.destroyDatatable();
      this.loadVendor();
    },

    pending1() {
      $("#active").addClass("d-none");
      $("#pending").removeClass("d-none");
      this.activeClick = false;
    },

    active1() {
      $("#pending").addClass("d-none");
      $("#active").removeClass("d-none");
      this.activeClick = true;
    },

    destroyDatatable() {
      $("#active_tbl")
        .DataTable()
        .destroy();
      $("#pending_tbl")
        .DataTable()
        .destroy();
    },

    redirect(data) {
      return "/lps/vendor/company/details/" + this.id;
    }
  },

  mounted() {
    this.loadData();
  }
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
